import { DocumentTemplate } from '../../../model/DocumentTemplate'
import { QuestionnaireTemplate, QuestionTemplate } from '../../../model/Questionnaire'
import { uiActionsFactory } from '../../restux/ui/restuxUiActions.factory'
import {
  DocumentTemplateCreateResource,
  managerDocumentTemplatesConfig,
  UiManagerDocumentTemplateActionTypes,
} from './managerDocumentTemplates.model'

const uiActions = uiActionsFactory(managerDocumentTemplatesConfig).actions

const addExistingQuestionToInUseDocumentTemplate = (
  documentTemplateId: number,
  selectedQuestion: QuestionTemplate,
  onQuestionAddedToDocumentTemplate: (question: QuestionTemplate) => void,
) => ({
  type: UiManagerDocumentTemplateActionTypes.ADD_EXISTING_QUESTION_TO_DOCUMENT_IN_USE_TEMPLATE,
  documentTemplateId,
  selectedQuestion,
  onQuestionAddedToDocumentTemplate,
})

const addQuestionnaireTemplateToInUseDocumentTemplate = (
  documentTemplateId: number,
  selectedQuestionnaire: QuestionnaireTemplate,
  onQuestionnaireAdded: (questionnaire: QuestionnaireTemplate) => void,
) => ({
  type: UiManagerDocumentTemplateActionTypes.ADD_QUESTIONNAIRE_TO_IN_USE_DOCUMENT_TEMPLATE,
  documentTemplateId,
  selectedQuestionnaire,
  onQuestionnaireAdded,
})

const createDocumentTemplate = (templateResources: DocumentTemplateCreateResource) => ({
  type: UiManagerDocumentTemplateActionTypes.CREATE,
  templateResources,
})

const updateDocumentTemplate = (
  documentTemplateId: number,
  documentTemplateUpdates: Partial<DocumentTemplate>,
) => ({
  type: UiManagerDocumentTemplateActionTypes.UPDATE,
  documentTemplateId,
  documentTemplateUpdates,
})

export const managerDocumentTemplatesActions = {
  ...uiActions,
  addExistingQuestionToInUseDocumentTemplate,
  addQuestionnaireTemplateToInUseDocumentTemplate,
  createDocumentTemplate,
  updateDocumentTemplate,
}
